import { AddToCartButton, WidgetReadyBoundary } from '@components'
import { useEventBusOn, productChannel } from '@haus-storefront-react/core'

type AddToCartButtonAttributes = {
  configStyles?: {
    buttonVariant?: {
      variant?: string
    }
  }
}

const AddToCartButtonWidget = ({ configStyles }: AddToCartButtonAttributes) => {
  const [selectedProductVariant] = useEventBusOn(productChannel, 'product:variant:selected')
  const inStock = selectedProductVariant?.stockLevel !== 'OUT_OF_STOCK'
  const buttonVariant = configStyles?.buttonVariant?.variant ?? 'primary'
  const isReady = Boolean(selectedProductVariant?.id)

  return (
    <WidgetReadyBoundary isReady={isReady}>
      <AddToCartButton
        key={selectedProductVariant?.id}
        productVariantId={selectedProductVariant?.id}
        inStock={inStock}
        productVariant={selectedProductVariant ?? undefined}
        buttonVariant={buttonVariant}
        productName={selectedProductVariant?.name}
      />
    </WidgetReadyBoundary>
  )
}

export default AddToCartButtonWidget
